__turbopack_context__.v({
  "className": "playfair_display_482484c5-module__07MdrG__className",
  "variable": "playfair_display_482484c5-module__07MdrG__variable",
});
